import { isOn } from '@mc/flags';
import { useExperiment } from '@mc/experiments';

const useSmsMultiEverythingExperiment = () => {
  const EXPERIMENT_NAME = 'multi-everything-msg-registrations-experiment';
  const EXPERIMENT_VARIANT = 'multi-everything-variant';
  const EXPERIMENT_CONTROL = 'multi-everything-control';

  // If the experiment is on and the flag is on, show the multi country components
  const variantName = useExperiment(EXPERIMENT_NAME);

  const isVariant = variantName === EXPERIMENT_VARIANT;
  const isControl = variantName === EXPERIMENT_CONTROL;
  const shouldShowMultiEverythingComponents =
    isOn(FLAGS.SMS_MULTI_COUNTRY) && isVariant;

  return {
    shouldShowMultiEverythingComponents,
    isVariant,
    isControl,
  };
};

export default useSmsMultiEverythingExperiment;
